
const eatAndPlayConfig = {
  breakfast: {
    omelets: {
      sideGroup: "breakfastSides",
      image: "poker/eat-and-play/Omeletts---Natural.jpg",
      items: {
        plain: {
          price: 4.00
        },
        denverOmelet: {
          price: 6.75
        },
        florentineOmelet: {
          price: 6.50
        },
        mexicanOmelet: {
          price: 8.00
        }
      }
    },
    eggs: {
      sideGroup: "breakfastSides",
      image: "poker/eat-and-play/Eggs---Two-eggs-1-meat-choice.jpg",
      items: {
        twoEggs1ChoiceOfMeat: {
          price: 8.75
        },
        twoEggsChoiceOfPancakesOrFrenchToast: {
          price: 10.25
        }
      }
    },
    breakfastBowls: {
      sideGroup: "breakfastSides",
      items: {
        montrealBowl: {
          price: 15.75,
          starred: true
        },
        ratatouilleBowl: {
          price: 14.00,
          starred: true
        },
        bbqBeefBowl: {
          price: 17.25,
          starred: true
        }
      }
    },
    breakfastSandwiches: {
      sideGroup: "breakfastSides",
      image: "poker/eat-and-play/24h-breakfast-Breakfast-Sandwich.jpg",
      items: {
        blt: {
          price: 7.75
        },
        baconGrilledCheese: {
          price: 7.25
        },
        breakfastSandwich: {
          price: 9.00
        },
        bagelLoxSchmear: {
          price: 15.75,
          starred: true
        },
        breakfastTacos: {
          price: 6.50
        },
        breakfastClub: {
          price: 9.50
        },
        breakfastBurrito: {
          price: 15.75
        }
      }
    },
    sweetTreats: {
      sideGroup: "sweetTreatSides",
      image: "poker/eat-and-play/Batter-Bar---3-Pancakes-Fruits.jpg",
      items: {
        classicFrenchToast: {
          price: 5.00
        },
        classicPancakeStack: {
          price: 5.00
        },
        berryExplosionPancakes: {
          price: 8.00,
          starred: true
        },
        applePiePancakes: {
          price: 7.00
        },
        choconanaPancakes: {
          price: 9.25
        }
      }
    },
    healthyChoices: {
      sideGroup: "breakfastSides",
      image: "poker/eat-and-play/Healthy-Choices---Fresh-Fruit-Salad.jpg",
      items: {
        avocadoToast: {
          price: 10.75,
          starred: true
        },
        smokedSalmonPlate: {
          price: 12.50,
          starred: true
        },
        toastOrBagelCheese: {
          price: 7.25
        },
        yogurtBowl: {
          price: 9.50
        },
        fruitSalad: {
          price: 6.00
        }
      }
    }
  },
  main: {
    starters: {
      sideGroup: "none",
      image: "poker/eat-and-play/Appetizers-Guacamole.jpg",
      items: {
        veggiePlateCrudite: {
          price: 10.00
        },
        chickenTenders3: {
          price: 10.00
        },
        butterflyShrimp5: {
          price: 9.50
        },
        pogo3: {
          price: 5.00
        },
        vegetarianImperialRolls3: {
          price: 6.25
        },
        generalTaoChickenBites: {
          price: 9.75
        },
        frenchFries: {
          price: 4.00
        },
        cheeseburgerSpringRoll2: {
          price: 12.00,
          starred: true
        },
        chiliCheeseFries: {
          price: 9.50,
          starred: true
        },
        parmesanFries: {
          price: 7.00,
          starred: true
        },
        sweetPotatoFries: {
          price: 4.75,
          starred: true
        },
        smallPoutine: {
          price: 4.00
        },
        chickenNoodleSoup: {
          price: 3.00
        }
      }
    },
    salads: {
      sideGroup: "saladAdditions",
      items: {
        cesarSalad: {
          price: "6.75 / 10.50"
        },
        greekSalad: {
          price: "7.00 / 12.00"
        },
        bistroSalad: {
          price: "11.25 / 16.00",
          starred: true
        },
        japaneseSalad: {
          price: "10.50 / 14.00",
          starred: true
        }
      }
    },
    burgersAndSandwiches: {
      sideGroup: "mainSides",
      image: "poker/eat-and-play/Hot-Burgers-Classic-Burger.jpg",
      items: {
        classicHamburger: {
          price: 9.50
        },
        classicCheeseburger: {
          price: 11.75
        },
        baconCheeseburger: {
          price: 13.25
        },
        bigStackBurger: {
          price: 11.00
        },
        friedChickenSandwich: {
          price: 11.00
        },
        blt: {
          price: 7.75
        },
        grilledCheese: {
          price: 7.25
        },
        clubSandwich: {
          price: 15.25
        },
        chickenBaconRanchWrap: {
          price: 15.00
        },
        beefShawarmaWrap: {
          price: 14.25
        },
        grilledChickenBanhMi: {
          price: 16.00
        },
        chickenShawarmaWrap: {
          price: 10.00
        },
        pulledBeefSub: {
          price: 15.25
        },
        smokedMeatSandwich: {
          price: 15.50
        },
        grilledChickenSaladSandwich: {
          price: 12.75
        },
        tunaSaladSandwich: {
          price: 10.00
        },
        makeItImpossible: {
          price: 5.00
        }
      }
    },
    landAndSea: {
      sideGroup: "mainSides",
      image: "poker/eat-and-play/Land-Sea-NYC-strip.jpg",
      items: {
        jerkChicken: {
          price: 14.50
        },
        hamburgerSteak: {
          price: 13.00
        },
        grilledChickenBreast: {
          price: 11.75
        },
        bavette: {
          price: 17.00
        },
        newYorkStrip: {
          price: 28.75,
          starred: true
        },
        fishChips: {
          price: 16.75
        },
        cajunSalmon: {
          price: 16.00
        },
        misoCod: {
          price: 16.00,
          starred: true
        }
      }
    },
    pasta: {
      sideGroup: "mainSides",
      image: "poker/eat-and-play/Pasta-Pasta.jpg",
      items: {
        pomodoro: {
          price: 9.25
        },
        bolognese: {
          price: 12.50
        },
        chickenBroccoliAlfredo: {
          price: 16.50,
          starred: true
        },
        baconMushroomRose: {
          price: 14.00
        },
        arrabiatta: {
          price: 9.75
        },
        primavera: {
          price: 18.50,
          starred: true
        },
        macCheese: {
          price: 11.25
        }
      }
    },
    bowls: {
      sideGroup: "mainSides",
      image: "poker/eat-and-play/bowls.jpg",
      items: {
        thaiBowl: {
          price: 17.00
        },
        mediterraneanBowl: {
          price: 19.00,
          starred: true
        },
        bbqBowl: {
          price: 12.00
        }
      }
    },
    poutine: {
      sideGroup: "mainSides",
      items: {
        classicPoutine: {
          price: 8.00
        },
        baconCheeseburgerPoutine: {
          price: 19.00,
          starred: true
        },
        sausagePeppersPoutine: {
          price: 13.75
        },
        pulledBeefPoutine: {
          price: 14.00
        },
        pogoPoutine: {
          price: 9.75
        },
        veggiePoutine: {
          price: 12.00
        }
      }
    },
    pizza: {
      sideGroup: "pizzaSides",
      image: "poker/eat-and-play/Pizza.jpg",
      items: {
        margherita: {
          price: 9.50
        },
        pepperoni: {
          price: 14.00
        },
        meatlovers: {
          price: 17.25,
          starred: true
        },
        allDressed: {
          price: 15.00
        },
        extravaganza: {
          price: 15.50,
          starred: true
        },
        mexican: {
          price: 15.50,
          starred: true
        },
        sweetDiavola: {
          price: 17.00,
          starred: true
        },
        bbqChicken: {
          price: 17.75,
          starred: true
        },
        cheesyGarlicBread: {
          price: 13.50
        }
      }
    },
    allDayBreakfast: {
      sideGroup: "mainSides",
      image: "poker/eat-and-play/24h-breakfast-Breakfast-Sandwich.jpg",
      items: {
        denverOmelet: {
          price: 6.75
        },
        florentineOmelet: {
          price: 6.50
        },
        mexicanOmelet: {
          price: 8.00
        },
        plainOmelet: {
          price: null
        },
        breakfastSandwich: {
          price: 9.00
        }
      }
    },
    desserts: {
      sideGroup: "none",
      image: "poker/eat-and-play/Desserts-Mousse-2.jpg",
      items: {
        cheesecake: {
          price: 9.00,
          starred: true
        },
        keyLimePie: {
          price: 8.50,
          starred: true
        },
        carrotCake: {
          price: 10.00
        },
        chocolateMousse: {
          price: 7.50
        },
        yogurtBowl: {
          price: 9.50
        },
        freshFruitSalad: {
          price: 6.00
        },
        slicedBanana: {
          price: 3.50
        },
        slicedApple: {
          price: 2.00
        }
      }
    }
  },
  extras: {
    omeletAdditions: {
      hideItemsOnCash: true,
      hideOnTournament: true,
      items: {
        meats: { price: null },
        ham: { price: 2.50 },
        bacon: { price: 2.50 },
        vegetables: { price: 1.25 },
        peppers: { price: 1.25 },
        onions: { price: 1.25 },
        mushroom: { price: 1.25 },
        spinach: { price: 1.25 },
        jalapeno: { price: 1.25 },
        cheeses: { price: null },
        swiss: { price: 1.75 },
        cheddar: { price: 1.75 },
        cheddarMontereyBlend: { price: 1.75 }
      }
    },
    sweetTreatSides: {
      items: {
        bacon: { price: 4.75 },
        sausage: { price: 4.75 },
        ham: { price: 4.75 },
        banana: { price: 1.00 }
      }
    },
    saladAdditions: {
      items: {
        grilledChickenBreast: { price: 10.00 },
        cajunSalmon: { price: 16.00 },
        hamburgerPatty: { price: 8.50 },
        chickenTenders: { price: 12.75 },
        jerkChickenThighs: { price: 14.00 },
        pulledBeef: { price: 12.75 },
        cajunTofu: { price: 3.50 }
      }
    },
    mainSides: {
      items: {
        avocado: { price: 2.25 },
        frenchFries: { price: 4.00 },
        parmesanFries: { price: 7.00 },
        sweetPotatoFries: { price: 4.00, starred: true },
        whiteRice: { price: 2.75 },
        mashedPotato: { price: 3.75 },
        sauteedVegetables: { price: 3.75 },
        smallClassicPoutine: { price: 6.50 },
        smallSweetPotatoPoutine: { price: 8.50, starred: true },
        cesarSalad: { price: 6.75 },
        greekSalad: { price: 7.00 },
        bistroSalad: { price: 11.25, starred: true },
        japaneseSalad: { price: 10.50, starred: true }
      }
    },
    signatureDips: {
      items: {
        mapleBbq: { price: 2.50 },
        hotSauce: { price: 2.50 },
        chipotleMayonnaise: { price: 2.50 },
        generalTaoSauce: { price: 2.50 },
        thaiSweetChiliSauce: { price: 2.50 },
        jalapenoMayonnaise: { price: 2.50 }
      }
    },
    proteinSides: {
      items: {
        grilledChicken: {
          price: 9.00
        },
        cajunSalmon: {
          price: 15.00
        },
        chickenTenders: {
          price: 10.00
        },
        falafel: {
          price: 4.00
        },
        grilledTofu: {
          price: 7.00
        }
      }
    },
    sauceSides: {
      items: {
        mapleBbq: {
          price: 2.50
        },
        hotSauce: {
          price: 2.50
        },
        chipotleMayo: {
          price: 2.50
        },
        generalTaoSauce: {
          price: 2.50
        },
        thaiSweetChili: {
          price: 2.50
        },
        jalapenoMayo: {
          price: 2.50
        }
      }
    },
    pizzaSides: {
      vegetables: {
        items: {
          redOnion: {
            price: 0.50
          },
          peppers: {
            price: 2.00
          },
          mushrooms: {
            price: 1.75
          },
          olives: {
            price: 1.50
          },
          jalapeno: {
            price: 0.50
          }
        }
      },
      meat: {
        items: {
          bacon: {
            price: 3.00
          },
          pepperoni: {
            price: 4.25
          },
          soppressata: {
            price: 6.75
          },
          sausage: {
            price: 3.00
          },
          chickenBreast: {
            price: 4.00
          },
          pulledBeef: {
            price: 1.75
          }
        }
      },
      cheese: {
        items: {
          mozzarella: {
            price: 3.50
          },
          feta: {
            price: 4.00
          }
        }
      }
    },
    regularSides: {
      items: {
        fries: {
          price: 5.00
        },
        smallGoddessSalad: {
          price: 7.50
        },
        smallGreekSalad: {
          price: 8.50
        },
        smallCaesarSalad: {
          price: 9.75
        },
        avocadoHalf: {
          price: 4.00
        },
        sauteedVegetables: {
          price: 5.00
        },
        whiteRice: {
          price: 3.00
        },
        mashedPotatoes: {
          price: 5.00,
          starred: true
        },
        sweetPotatoFries: {
          price: 5.00,
          starred: true
        },
        smallPoutine: {
          price: 6.00
        },
        sweetPotatoPoutine: {
          price: 7.00,
          starred: true
        }
      }
    },
    breakfastSides: {
      items: {
        breakfastPotatoes: {
          price: 3.25
        },
        avocado: {
          price: 2.25
        },
        bakedBeans: {
          price: 1.50
        },
        slicedTomatoes: {
          price: 3.25
        },
        bacon: {
          price: 4.75
        },
        sausage: {
          price: 4.75
        },
        ham: {
          price: 4.75
        },
        egg1: {
          price: 1.00
        }
      }
    }
  }
};

export default eatAndPlayConfig;
